import React from "react";
import { ReactComponent as BTCIcon } from "../../../../assets/images/bitcoin-icon.svg";
import { formatNumber } from "../../../../services/utility/utils";
import { useSelector } from "react-redux";
import { getContestsCarouselLive } from "../../../../redux/contests/selectors";
import useScreen, { SCREEN_LIST } from "../../../../hook/useScreen";
import { formatCoin, renderPercent } from "../../../../utils/utils";

export default function TitleMobile(props: any) {
  const { lang, livePrice, indexCard, operatorId } = props;
  const itemLive = useSelector(getContestsCarouselLive)?.[0];
  const lockPrice = itemLive?.livePrice || 0;

  const heightScreen = useScreen();

  const isHeightMin = heightScreen <= SCREEN_LIST.screenHeight2;

  const isCoinUp = livePrice > lockPrice;

  return (
    <div className="content-title content-title-mobile">
      {indexCard === 0 && (
        <div
          className={`animate__animated animate__zoomIn animate-duration-03 wrap-title-will-bitcoin ${
            isHeightMin && "wrap-title-will-bitcoin-min"
          }`}
        >
          <div
            className={`will-bitcoin`}
            dangerouslySetInnerHTML={{
              __html:
                operatorId === 2
                  ? lang?.bitcoin_up_down_best_swap || "Will <span class='label__bitcoin'>Bitcoin</span go <span class='label__up'>UP</span> or <span class='label__down'>DOWN</span>"
                  : lang?.bitcoin_up_down || "Will Bitcoin go UP or DOWN",
            }}
          />
          <p className="next-round">
            {lang?.the_next_round || "in the next round"}?
          </p>
        </div>
      )}
      {indexCard !== 0 && (
        <div className="wrap-icon-value-coin-live animate__animated animate__zoomIn animate-duration-03">
          <BTCIcon className="btc-icon" />
          <p className="live-price-label yellow">
            {lang?.live_bitcoin_price || "Live Bitcoin Price"}
          </p>
          <p
            className={`live-price-value
      live-price-value-${!lockPrice ? "down" : isCoinUp ? "up" : "down"}
      `}
          >
            <span>$</span>
            <p>
              {formatCoin(livePrice, 0)}.<span>{renderPercent(livePrice)}</span>
            </p>
          </p>
        </div>
      )}
    </div>
  );
}
